import { Button, Checkbox, Container, FormControl, FormErrorMessage, FormLabel, Input, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select } from "@chakra-ui/react";
import { Field, Form, Formik } from "formik";
import { FC, useEffect, useState } from "react";
import OrderService from "services/orders/order-service";
import LogosNotification from "utils/notification-utils";
import PartnerService from "../../../services/partners/partner-service";

interface TransferDialogDialogProps {
    withdraw: any
    onClose: any,
    onRefreshData: any
};

const formInitialValue = {
    screenshot: null
};

const TransferDialog: FC<TransferDialogDialogProps> = ({ withdraw, onClose, onRefreshData }) => {
    const [formValue, setFormValue] = useState<any>(formInitialValue);
    const [isSubmiting, setIsSubmiting] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const handleFormSubmit = (values: any) => {
        setIsSubmiting(true);
        PartnerService.TransferRequestWithdraw(withdraw.partner.partnerId, withdraw.id, values.screenshot).then((res: any) => {
            onRefreshData(res.result);
        }).finally(() => {
            setIsSubmiting(false);
        })
    };

    const formValidation = (values: any) => {
        if (values.screenshot == null)
            return { screenshot: 'Silahkan upload bukti transfer' };
    };

    return (
        <Modal isOpen={true} onClose={onClose} >
            <ModalOverlay />
            <ModalContent>
                {
                    isLoading && "Loading..."
                }
                {
                    !isLoading &&
                    <Formik initialValues={formValue} onSubmit={handleFormSubmit} validate={formValidation}>
                        {
                            ({ handleSubmit, errors, touched, setFieldValue }) => (
                                <Form onSubmit={handleSubmit} noValidate={true}>
                                    <ModalHeader textAlign={"center"}>Pembayaran Komisi {withdraw.partnerName}</ModalHeader>
                                    <ModalBody pt={5}>

                                        <FormControl isRequired isInvalid={!!(errors.screenshot && touched.screenshot)} mt={4}>
                                            <FormLabel htmlFor='screenshot'>Bukti Transfer</FormLabel>
                                            <input
                                                type={'file'}
                                                id='screenshot'
                                                name={'screenshot'}
                                                accept="image/*"
                                                onChange={(event: any) => {
                                                    setFieldValue("screenshot", event.currentTarget.files[0]);
                                                }}
                                            />
                                            <FormErrorMessage>{errors.screenshot}</FormErrorMessage>
                                        </FormControl>

                                    </ModalBody>
                                    <ModalFooter>
                                        <Button variant={'outline'} mr={3} onClick={onClose}>
                                            Close
                                        </Button>
                                        <Button type={'submit'} isLoading={isSubmiting}>Bayar Sekarang</Button>
                                    </ModalFooter>
                                </Form>
                            )
                        }
                    </Formik>
                }
            </ModalContent>
        </Modal>
    );
};

export default TransferDialog;
